import React from 'react';
import { Button } from '@mui/material';
import { STModal } from '../../../commons/Modal';
import { getPolyglot } from '../../../../i18n';
import { useShowErrorMessage, useShowMessage } from '../../../../util/hooks';
import { useNavigate } from 'react-router-dom';
import { useGroupById } from '../../../../redux/groups/hooks/useGroupById';
import { GroupAPI } from '../../../../redux/groups/api/GroupAPI';
import { STModalProps } from '../../../commons/Modal/STModal/STModal';
import LoadingButton from '@mui/lab/LoadingButton';

interface RemoveGroupDeviceProps extends Omit<STModalProps, 'children'> {
  groupId?: string;
  deviceId?: string;
}
/** Transform Class component to functional */
function RemoveGroupDevice(props: RemoveGroupDeviceProps) {
  const { groupId = '', deviceId = '', onClose } = props;
  const showMessage = useShowMessage();
  const showErrorMessage = useShowErrorMessage();
  const navigate = useNavigate();
  const polyglot = getPolyglot();
  const { data: group } = useGroupById(groupId);
  const [deleteGroupDevice, { isLoading: isDeletingGroupDevice }] =
    GroupAPI.useDeleteDeviceGroupMutation();
  const removeGroupDevice = async () => {
    try {
      await deleteGroupDevice({ groupId, commanderId: deviceId }).unwrap();
      showMessage(polyglot.t('device.remove_successful_message'));
      onClose?.();
      navigate(`/devicemanager/group/${groupId}`, { replace: true });
    } catch (error) {
      showErrorMessage(error);
    }
  };

  const dialogText = polyglot
    .t('device.remove_group_device_dialog_text')
    .replace('#text', group ? `"${group?.name}"` : '');

  return (
    <STModal
      {...props}
      title={polyglot.t('device.remove_dialog_title')}
      buttonActions={
        <>
          <Button
            onClick={onClose}
            variant="text"
            disabled={isDeletingGroupDevice}
          >
            {polyglot.t('device.cancel_button_title')}
          </Button>
          <LoadingButton
            variant="contained"
            color="error"
            onClick={removeGroupDevice}
            loading={isDeletingGroupDevice}
          >
            {polyglot.t('device.remove_button_title')}
          </LoadingButton>
        </>
      }
    >
      <p>{dialogText}</p>
    </STModal>
  );
}

export default RemoveGroupDevice;
